import { memo } from 'react';

function WarningIcon() {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="18"
			height="18"
			fill="none"
			viewBox="0 0 18 18"
		>
			<path
				fill="#DB942A"
				fillRule="evenodd"
				d="M9 17.42A8.333 8.333 0 109 .753 8.333 8.333 0 109 17.42zm-1.25-4.174c0-.723.549-1.243 1.242-1.243.708 0 1.257.52 1.257 1.243 0 .722-.549 1.257-1.257 1.257a1.228 1.228 0 01-1.243-1.257zm.56-9.16a.417.417 0 00-.416.436l.255 5.833a.417.417 0 00.416.398h.87a.417.417 0 00.416-.398l.254-5.833a.417.417 0 00-.416-.435h-1.38z"
				clipRule="evenodd"
			></path>
		</svg>
	);
}

export default memo(WarningIcon);
